<template>
    <BreadCrumb PageTitle="Faire une inscription" />
    <AddInscription/>
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import AddInscription from "../../components/Inscription/AddInscription.vue"
  
    export default defineComponent({
      name: "AddInscriptionPage",
      components: {
        BreadCrumb,
        AddInscription,
      },
    });
  </script>